import React, { useState, useMemo, useEffect, useCallback } from "react";

const CloseOpModal = ({
  open,
  onCancel,
  onConfirm,
  jobNum,
  opNum,
  totalPieces,
}) => {
  const [passCount, setPassCount] = useState("");
  const [failCount, setFailCount] = useState("");

  useEffect(() => {
    if (!open) {
      setPassCount("");
      setFailCount("");
    }
  }, [open]);

  const valid = useMemo(() => {
    const p = Number(passCount);
    const f = Number(failCount);
    return Number.isInteger(p) && Number.isInteger(f) && p >= 0 && f >= 0;
  }, [passCount, failCount]);

  const handlePassChange = useCallback((e) => {
    setPassCount(e.target.value);
  }, []);

  const handleFailChange = useCallback((e) => {
    setFailCount(e.target.value);
  }, []);

  const handleConfirm = useCallback(() => {
    onConfirm?.({ pass: Number(passCount), fail: Number(failCount) });
  }, [onConfirm, passCount, failCount]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          width: 420,
          borderRadius: 8,
          padding: 16,
        }}
      >
        <h3 style={{ marginTop: 0, marginBottom: 8 }}>Close Operation</h3>
        <div style={{ fontSize: 14, color: "#555", marginBottom: 12 }}>
          <div>
            <strong>Job:</strong> {jobNum}
          </div>
          <div>
            <strong>Operation #:</strong> {opNum ?? "—"}
          </div>
          {typeof totalPieces === "number" && (
            <div>
              <strong>Total Pieces:</strong> {totalPieces}
            </div>
          )}
        </div>

        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}
        >
          <div>
            <label
              htmlFor="close-pass"
              style={{ display: "block", marginBottom: 6 }}
            >
              # Pass
            </label>
            <input
              id="close-pass"
              type="number"
              inputMode="numeric"
              value={passCount}
              onChange={handlePassChange}
              placeholder="e.g., 10"
              style={{
                width: "100%",
                padding: 8,
                border: "1px solid #ccc",
                borderRadius: 4,
              }}
            />
          </div>
          <div>
            <label
              htmlFor="close-fail"
              style={{ display: "block", marginBottom: 6 }}
            >
              # Fail
            </label>
            <input
              id="close-fail"
              type="number"
              inputMode="numeric"
              value={failCount}
              onChange={handleFailChange}
              placeholder="e.g., 2"
              style={{
                width: "100%",
                padding: 8,
                border: "1px solid #ccc",
                borderRadius: 4,
              }}
            />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: 8,
            justifyContent: "flex-end",
            marginTop: 16,
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "8px 14px",
              background: "#eee",
              border: "1px solid #ddd",
              borderRadius: 4,
              color: "#333",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={!valid}
            style={{
              padding: "8px 14px",
              background: "#007bff",
              border: "none",
              borderRadius: 4,
              color: "#fff",
              opacity: valid ? 1 : 0.6,
              cursor: valid ? "pointer" : "not-allowed",
            }}
          >
            Close Operation
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CloseOpModal);